import ShoppingProductButton from '@components/Product/ShoppingProductButton';
import { ProductCardsBlockItem as ProductCardsBlockItemType } from '../../productCardsBlock.types';
import { ProductCardsBlockVariant } from '../../productCardsBlock.types';
import RachelProductCard from '../RachelProductCard/RachelProductCard';
import RachelProductRow from '../RachelProductRow/RachelProductRow';
import { useProductCardsBlockItem } from './useProductCardsBlockItem';

interface ProductCardsBlockItemProps {
  product: ProductCardsBlockItemType;
  variant: ProductCardsBlockVariant;
}

const ProductCardsBlockItem = ({ product, variant }: ProductCardsBlockItemProps) => {
  const { colors, price, shopping, onOpenDetails } = useProductCardsBlockItem(product);

  if (variant === 'row') {
    return (
      <RachelProductRow product={product} colors={colors} price={price} onClick={onOpenDetails} />
    );
  }

  return (
    <RachelProductCard
      product={product}
      colors={colors}
      price={price}
      onClick={onOpenDetails}
      action={{
        isPinned: shopping.isShopping,
        content: (
          <ShoppingProductButton
            isShopping={shopping.isShopping}
            isLoading={shopping.isLoading}
            canAddShopping={product.availableForSale}
            tabIndex={0}
            onClickShopping={shopping.onClick}
          />
        ),
      }}
    />
  );
};

export default ProductCardsBlockItem;
